export const OWNER_PROFILE = {
  name: "Patrick Jay Timmens",
  title: "Founder & Owner",
  email: "timmens0722@gmail.com",
};

export const CURRENT_RECIPIENT = {
  name: "RECIPIENT TO BE SELECTED",
  status: "PARTNER SELECTION PENDING",
  description: "A verified after-deployment support partner will be selected for this cycle.",
};

const ROTATION_CYCLES = [
  { label: "JAN–APR", startMonth: 0 },
  { label: "MAY–AUG", startMonth: 4 },
  { label: "SEP–DEC", startMonth: 8 },
];

export function getDonationRotation(date = new Date()) {
  const year = date.getFullYear();
  const cycle = ROTATION_CYCLES[Math.floor(date.getMonth() / 4)];
  const nextYear = cycle.startMonth === 8 ? year + 1 : year;
  const nextMonth = cycle.startMonth === 8 ? 0 : cycle.startMonth + 4;
  const nextDate = new Date(nextYear, nextMonth, 1);
  return {
    currentCycle: `${cycle.label} ${year}`,
    nextRotation: nextDate.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }),
  };
}
